// 단어 데이터 로더 유틸리티

// 각 등급 코드별 JSON 파일 동적 import
const loadWordData = async (gradeCode) => {
  try {
    const module = await import(`../data/${gradeCode}.json`);
    return module.default;
  } catch (error) {
    console.error(`단어 데이터 로딩 오류 (${gradeCode}):`, error);
    return null;
  }
};

// 전체 단어 데이터 로드
const loadAllWordData = async () => {
  try {
    const module = await import('../data/allWords.json');
    return module.default;
  } catch (error) {
    console.error('전체 단어 데이터 로딩 오류:', error);
    return [];
  }
};

// 학교급과 학년에 따른 등급 코드 매핑
const getGradeCode = (schoolLevel, grade) => {
  const mapping = {
    '초등': {
      3: 'base1', // 초등 3-4학년
      4: 'base1',
      5: 'base2', // 초등 5-6학년  
      6: 'base2'
    },
    '중등': {
      1: 'base3',
      2: 'base4', 
      3: 'base5'
    },
    '고등': {
      1: 'base6',
      2: 'base7',
      3: 'base8'
    },
    '심화': {
      1: 'base9' // 심화과정
    },
    // 영어 키도 호환성을 위해 유지
    elementary: {
      1: 'base1',
      2: 'base1', 
      3: 'base1',
      4: 'base1',
      5: 'base2',
      6: 'base2'
    },
    middle: {
      1: 'base3',
      2: 'base4',
      3: 'base5'
    },
    high: {
      1: 'base6',
      2: 'base7',
      3: 'base8'
    },
    advanced: {
      1: 'base9'
    }
  };

  return mapping[schoolLevel]?.[grade] || null;
};

// 학교급과 학년에 따른 단어 데이터 로드
export const loadWordsByLevel = async (schoolLevel, grade) => {
  const gradeCode = getGradeCode(schoolLevel, grade);
  if (!gradeCode) {
    console.error(`지원하지 않는 학교급/학년: ${schoolLevel} ${grade}`);
    return [];
  }

  const data = await loadWordData(gradeCode);
  return data?.words || [];
};

// 랜덤하게 단어 선택 (새로운 데이터 구조: {english, korean} 객체 배열)
export const getRandomWords = (words, count) => {
  if (!Array.isArray(words) || words.length === 0) {
    return [];
  }

  // words 배열이 이미 {english, korean} 형태의 객체들이므로 그대로 셔플
  const shuffled = [...words].sort(() => Math.random() - 0.5);
  return shuffled.slice(0, Math.min(count, shuffled.length));
};

// 단어 데이터가 이미 {english, korean} 형태이므로 이 함수는 더 이상 필요하지 않음
// 호환성을 위해 유지하되 그대로 반환
export const formatWordsForFlashCard = (words) => {
  return words; // words는 이미 {english: string, korean: string} 형태
};

// 학교급별 등급 정보 조회
export const getGradeInfo = async () => {
  const allData = await loadAllWordData();
  return allData.map(data => ({
    gradeCode: data.grade_code,
    level: data.level,
    name: data.name,
    wordCount: data.words.length
  }));
};

// 특정 등급의 상세 정보 조회
export const getGradeDetail = async (gradeCode) => {
  const data = await loadWordData(gradeCode);
  return data;
};

export default {
  loadWordsByLevel,
  getRandomWords,
  formatWordsForFlashCard,
  getGradeInfo,
  getGradeDetail
};